import { render, staticRenderFns } from "./ContentsCatalog.vue?vue&type=template&id=07cfdcbe&"
import script from "./ContentsCatalog.vue?vue&type=script&lang=js&"
export * from "./ContentsCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ContentsCatalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports